<script lang="ts">
  import { track } from "../../helpers/mixpanel";
  import type { IntegrationDetails, Platform } from "../../helpers/types";
  import { activeIntegrationsStore } from "../../stores/integrations-store";
  import IntegrationPlatformRow from "./IntegrationPlatformRow.svelte";
  import { selectedBuyer } from "../../stores/buyer";

  export let selectedIntegration: IntegrationDetails | null;
  export let platformSelected = (
    _platformName: string,
    _platform: IntegrationDetails | undefined
  ) => {};

  let integrations: IntegrationDetails[] = [];

  let accountingPlatforms: Platform[] = [
    {
      name: "Square",
      logo: "",
      description: "",
      active: false,
      disabled: $selectedBuyer?.role !== "admin",
    },
    {
      name: "Xero",
      logo: "",
      description: "",
      active: false,
      disabled: false,
    },
    {
      name: "QuickbooksOnline",
      logo: "",
      description: "",
      active: false,
      disabled: false,
    },
  ];

  let managementPlatforms: Platform[] = [
    {
      name: "Tevalis",
      logo: "",
      description: "",
      active: false,
      disabled: false,
    },
    {
      name: "MarketMan",
      logo: "",
      description: "",
      active: false,
      disabled: false,
    },
    // {
    //   name: "REKKI_BUYER_API",
    //   logo: "",
    //   description: "",
    //   active: false,
    //   disabled: false,
    // },
  ];

  activeIntegrationsStore.subscribe((value) => {
    integrations = value;

    const [existingAccounting, existingManagement] = integrations?.reduce(
      (acc, integration) => {
        if (
          accountingPlatforms.find(
            (platform) =>
              integration.platform === platform.name || integration.platform === "QuickbooksOnline"
          )
        ) {
          acc[0].push(integration);
          return acc;
        }

        if (
          managementPlatforms.find(
            (platform) => integration.platform.toLowerCase() === platform.name.toLowerCase()
          )
        ) {
          acc[1].push(integration);
          return acc;
        }

        return acc;
      },
      [[], []] as IntegrationDetails[][]
    );

    accountingPlatforms = accountingPlatforms.flatMap((accPlatform) => {
      if (accPlatform.disabled) {
        return [];
      }

      if (!existingAccounting.length) {
        accPlatform.active = false;
        accPlatform.disabled = false;
        return accPlatform;
      }

      const exists = existingAccounting.find(
        (int) => int.platform.toLowerCase() === accPlatform.name.toLowerCase()
      );
      accPlatform.active = !!exists;
      accPlatform.disabled = !exists;
      return accPlatform;
    });

    managementPlatforms = managementPlatforms.map((managementPlatform) => {
      if (!existingManagement.length) {
        managementPlatform.active = false;
        managementPlatform.disabled = false;
        return managementPlatform;
      }

      const exists = integrations?.find(
        (int) => int.platform.toLowerCase() === managementPlatform.name.toLowerCase()
      );
      managementPlatform.active = !!exists;
      managementPlatform.disabled = !exists;

      return managementPlatform;
    });
  });

  const onClick = (platformName: string) => {
    track("integration_platform_clicked", {
      buyer_id: $selectedBuyer?.id,
      buyer_name: $selectedBuyer?.name,
      platformName,
    });

    const selectedIntegration = integrations.find(
      (activeInt) => activeInt.platform == platformName
    );

    platformSelected(platformName, selectedIntegration);
  };
</script>

<div class="container">
  <h1 class="title">integrations</h1>
  <h4 class="subtitle">reconciliation and recording stock made easy with REKKI integrations</h4>
  <div class="platform-type-container">
    <h2 class="platform-type">accounting</h2>
    <div class="platform-container">
      {#each accountingPlatforms as platform}
        <IntegrationPlatformRow
          onClick={(platform) => onClick(platform.name)}
          active={selectedIntegration?.platform === platform.name}
          {platform}
        />
      {/each}
    </div>
  </div>
  <div class="platform-type-container">
    <h2>stock management</h2>
    <div class="platform-container">
      {#each managementPlatforms as platform}
        <IntegrationPlatformRow
          onClick={(platform) => onClick(platform.name)}
          active={selectedIntegration?.platform === platform.name}
          {platform}
        />
      {/each}
    </div>
  </div>
</div>

<style>
  .container {
    border-top: 1px solid;
    padding: 18px;
    border-color: var(--rekki-neutral-01);
    width: 100%;
  }

  .title {
    font-weight: bold;
    font-size: 32px;
  }

  .subtitle {
    font-size: 18px;
    font-weight: normal;
  }
  .platform-type-container {
    margin-top: 40px;
  }

  .subtitle {
    color: var(--rekki-neutral-03);
  }
  .platform-container {
    margin-top: 18px;
    display: flex;
    flex-direction: row;
  }

  @media screen and (max-width: 1680px) {
    .container {
      min-width: 250px;
      overflow-y: auto;
    }

    .platform-container {
      flex-direction: column;
    }

    .title {
      max-width: 100%;
    }

    .subtitle {
      max-width: 100%;
    }
  }
</style>
